<template>
  <div
    v-for="(category, mainCategoryIndex) in props.list"
    :key="category.name"
    class="my-2"
  >
    <NuxtLinkWithLocale
      :to="category.route"
      :data-testid="`${dataTestid}-parentcategory-${mainCategoryIndex}-link`"
      class="bg-info/10 group block overflow-hidden w-full relative rounded py-6 pl-4 hover:text-primary hover:bg-info/15 cursor-pointer transition-colors duration-200 ease-in-out"
    >
      <span class="text-2xl font-bold leading-[22px]">{{ category.name }}</span>
      <TsIcon
        v-if="Object.keys(categoryIcons).includes(category.name)"
        :name="categoryIcons[category.name]"
        size="80"
        class="absolute right-2.5 top-2.5 text-natural-silver-grey"
      />
    </NuxtLinkWithLocale>
    <div v-if="category.children?.length" class="py-5">
      <div
        v-for="(childCategory, childCategoryIndex) in category.children"
        :key="childCategory.name"
        class="border-b last:border-b-0 py-4"
      >
        <NuxtLinkWithLocale
          :to="childCategory.route"
          :data-testid="`${dataTestid}-childcategory-${childCategoryIndex}-link`"
          class="leading-[22px] font-bold cursor-pointer hover:underline hover:text-primary transition-colors duration-200"
          >{{ childCategory.name }}</NuxtLinkWithLocale
        >

        <TsRow
          v-if="childCategory.children?.length"
          class="gap-3 px-2 flex-wrap mt-2"
        >
          <NuxtLinkWithLocale
            v-for="(
              grandChildCategory, grandChildCategoryIndex
            ) in childCategory.children"
            :to="grandChildCategory.route"
            :key="grandChildCategory.name"
            class="max-w-min whitespace-nowrap cursor-pointer text-sm text-natural-grey hover:underline"
            :data-testid="`${dataTestid}-grandchildcategory-${grandChildCategoryIndex}-link`"
            >{{ grandChildCategory.name }}</NuxtLinkWithLocale
          >
        </TsRow>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { categoryIcons } from "~/assets/constants/ui";
import type { CategorySiteMapStructure } from "~/types/ecom/sitemap.type";

type Props = {
  list: CategorySiteMapStructure[];
  dataTestid?: string;
};

const props = withDefaults(defineProps<Props>(), {});
</script>
